import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export const useSparePartTypesOrganization = () => {
  const fetch = useFetch<Endpoints['GET /spare-part-types/organization']>();

  return useQuery({
    queryKey: ['spare-part-types', 'organization'],
    queryFn: () => fetch('/spare-part-types/organization'),
  });
};

export const useDeleteSparePartType = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['DELETE /spare-part-types/:id']>();

  return useMutation({
    mutationFn: (id: string) => fetch(`/spare-part-types/${id}`, undefined, { method: 'DELETE' }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['spare-part-types'] });
    },
  });
};

export const useUpdateSparePartType = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['PATCH /spare-part-types/:id']>();

  return useMutation({
    mutationFn: ({
      sparePartTypeId,
      ...body
    }: {
      sparePartTypeId: string;
    } & Endpoints['PATCH /spare-part-types/:id']['body']) =>
      fetch(`/spare-part-types/${sparePartTypeId}`, undefined, { method: 'PATCH', body }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['spare-part-types', 'organization'] });
    },
  });
};

export const useCreateSparePartType = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['POST /spare-part-types']>();

  return useMutation({
    mutationFn: (body: Endpoints['POST /spare-part-types']['body']) =>
      fetch(`/spare-part-types`, undefined, { method: 'POST', body }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['spare-part-types', 'organization'] });
    },
  });
};
